export const enum WORKFLOW_MENU_ACTIONS {
	DUPLICATE = 'duplicate',
	DOWNLOAD = 'download',
	IMPORT = 'import',
	IMPORT_FROM_URL = 'import-from-url',
	IMPORT_FROM_FILE = 'import-from-file',
	PUSH = 'push',
	EDIT_DESCRIPTION = 'edit-description',
	SETTINGS = 'settings',
	DELETE = 'delete',
	ARCHIVE = 'archive',
	UNARCHIVE = 'unarchive',
	RENAME = 'rename',
	VERSION_HISTORY = 'version-history',
	PRODUCTION_CHECKLIST = 'production-checklist',
	CHANGE_OWNER = 'change-owner',
	UNPUBLISH = 'unpublish',
	SHARE = 'share',
	FAVORITE = 'favorite',
}
